const { on } = window.ivent;

function calculateDiscountPercentage(originalPrice, discountedPrice) {
	return Math.round(((originalPrice - discountedPrice) / originalPrice) * 100);
}

function setDiscount() {
	document.querySelectorAll('.tier-discount').forEach((el) => {
		// Return when init discount.
		if (parseFloat(el.getAttribute('data-tier-discount')) !== 0) {
			return;
		}

		const month = parseInt(
			el.getAttribute('data-tier-month').replace(/\D/g, ''),
		);
		const year = parseInt(el.getAttribute('data-tier-year').replace(/\D/g, ''));
		const discountedPrice = year / 12;

		el.setAttribute(
			'data-tier-discount',
			calculateDiscountPercentage(month, discountedPrice),
		);
	});
}

setDiscount();

on(document, 'pvs.navigation.content-rendered', setDiscount);
